import PartyPivotReport from "@/components/PartyPivotReport";

const PARTY_TYPES = [
  { value: "all", label: "All Parties" },
  { value: "debtor", label: "Sundry Debtors" },
  { value: "branch", label: "Branches" },
  { value: "related", label: "Related / Capital" },
  { value: "other", label: "Other" },
];

export default function PartySales({ companyContext }) {
  return (
    <PartyPivotReport
      companyContext={companyContext}
      endpoint="party-sales"
      title="Party-wise Sales Report"
      subtitle="Monthly breakdown by customer. Click any row to see item-wise detail. Download Excel for full breakdown."
      partyTypeOptions={PARTY_TYPES}
      totalColor="text-green-700"
      testIdPrefix="party-sales"
    />
  );
}
